import React, { FC } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { AvatarFragmentFragment } from "@graphqlTypes"

import "./Avatar.scss"

export enum AVATAR_SIZES {
  S = "S",
  M = "M",
  L = "L",
  XL = "XL"
}

type AvatarProps = AvatarFragmentFragment & {
  size?: AVATAR_SIZES,
}

const Avatar: FC<AvatarProps> = ({
  name,
  size = AVATAR_SIZES.M,
  image,
}) => image ? (
  <div className={`Avatar size--${size}`}>
    <GatsbyImage
      alt={name || image.title || "Avatar"}
      image={image?.imgixImage?.gatsbyImageData}
    />
  </div>
) : null

export const AvatarFragment = graphql`
  fragment AvatarFragment on ContentfulPerson {
    name
    image {
      imgixImage {
        gatsbyImageData(width: 160)
      }
      title
    }
  }
`

export default Avatar
